
import * as ipxRuntime$KjJpLWibA_qTjk6Iw3adANTrr5nygMybnB46NjswohI from '/build/b374d905-fc78-4032-93e7-3c58233cb01e/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$KjJpLWibA_qTjk6Iw3adANTrr5nygMybnB46NjswohI, defaults: {} }
}
        